import { getURLParams } from 'src/helpers/actions/local/core/local_action_parse_url_helpers';
//Types
import type { ActionJob } from 'src/types/requests/schedules/schedules_g2';

export const validatePresenceURLWebhook = (url: string): ActionJob | null => {
	const action: ActionJob = getURLParams(url);
	if (action.method === 'presencezone.setconfig') {
		const config = action.params?.config;
		action.error = action.error || !config || config?.enable == null;
	}
	return action;
};
